<template>
  <div>
    <p class="text-center" style="margin-bottom:12px;font-size:18px;font-weight:bold">{{ student.studentName ? '修改' : '填写' }}个人资料</p>
    <el-card class="box-card">
      <el-form :model="formData" :rules="rules" ref="formEdit" label-width="100px">
        <el-form-item prop="studentName">
          <div class="info_box" style="margin-top: 5px">
            <div>姓名</div>
            <el-input v-model="formData.studentName" />
          </div>
        </el-form-item>
        <el-form-item prop="studentNo">
          <div class="info_box">
            <div>学号</div>
            <el-input v-model="formData.studentNo" />
          </div>
        </el-form-item>
        <el-form-item prop="studentGendar">
          <div class="info_box" style="padding-bottom:5px;border-bottom: 1px solid #d2d9f1;">
            <div>性别</div>
            <el-radio-group v-model="formData.studentGendar" size="small">
              <el-radio label="男">男</el-radio>
              <el-radio label="女">女</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item prop="studentBirtYear">
          <div class="info_box info_box_down">
            <div>出生年份</div>
            <el-date-picker style="width: 100%" v-model="formData.studentBirtYear" type="year" placeholder="选择年"
                            value-format="yyyy" prefix-icon=null />
          </div>
        </el-form-item>
        <el-form-item prop="studentHome">
          <div class="info_box">
            <div>生源地</div>
            <el-cascader style="width: 100%" size="medium" :options="provinceAndCityData" v-model="formData.studentHome"
                         clearable/>
          </div>
        </el-form-item>
        <el-form-item prop="collegeAndMajor">
          <div class="info_box">
            <div>学院/专业</div>
            <el-cascader style="width: 100%" size="medium" :options="collegeAndMajorData"
                         v-model="formData.collegeAndMajor"
                         clearable/>
          </div>
        </el-form-item>
        <el-form-item prop="studentGrade">
          <div class="info_box">
            <div>入学年份</div>
            <el-date-picker style="width: 100%" v-model="formData.studentGrade" type="year" placeholder="选择年"
                            value-format="yyyy" prefix-icon=null />
          </div>
        </el-form-item>
        <el-form-item prop="studentDegree">
          <div class="info_box">
            <div>学历</div>
            <el-select style="width: 100%" v-model="formData.studentDegree" placeholder="请选择学历" size="small">
              <el-option label="专科" value="专科"></el-option>
              <el-option label="本科" value="本科"></el-option>
              <el-option label="硕士" value="硕士"></el-option>
              <el-option label="博士" value="博士"></el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>

    </el-card>
    <div class="mt10 button_box" :class='student.studentName ? "" : "button_center"'>
      <el-button class="el_button_2" v-if="student.studentName" type="info" round size="small" @click="cancalEdit">
        取消
      </el-button>
      <el-button class="el_button_2" type="primary" round size="small" @click="saveEditStudent">确定</el-button>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import HttpRequest from "@/utils/request";
import axios from "axios";
import qs from "qs";
import {provinceAndCityData, TextToCode, CodeToText} from 'element-china-area-data'

export default {
  data() {
    var validateStudentNo = (rule, value, callback) => {
      var myreg = /^[a-zA-Z0-9]{4,16}$/
      if (value === '') {
        callback(new Error('学号不能为空'))
      } else if (!myreg.test(value)) {
        callback(new Error('学号只能填写字母或数字'))
      } else {
        callback()
      }
    };
    var validateChinese = (rule, value, callback) => {
      const reg = /^[A-Za-z\u4e00-\u9fa5\s•·]+$/;
      if (!reg.test(value)) {
        callback(new Error('只能输入汉字'));
      } else {
        callback();
      }
    };
    return {
      provinceAndCityData,
      collegeAndMajorData: [],
      formData: {
        studentName: '',
        studentNo: '',
        studentGendar: '',
        collegeAndMajor: [],
        studentGrade: '',
        studentHome: [],
        studentBirtYear: '',
        studentDegree: '',
      },
      rules: {
        studentNo: [
          {required: true, message: '请输入学号', trigger: 'blur'},
          {validator: validateStudentNo, trigger: 'blur'},
        ],
        studentName: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
          { validator: validateChinese, trigger: 'blur' }
        ],
        studentGendar: [
          {required: true, message: '请选择性别', trigger: 'change'}
        ],
        collegeAndMajor: [
          {type: 'array', required: true, message: '请选择学院/专业', trigger: 'change'}
        ],
        studentGrade: [
          {required: true, message: '请选择入学年份', trigger: 'change'}
        ],
        studentHome: [
          {type: 'array', required: true, message: '请选择生源地', trigger: 'change'}
        ],
        studentBirtYear: [
          {required: true, message: '请选择出生年份', trigger: 'change'}
        ],
        studentDegree: [
          {required: true, message: '请选择学历', trigger: 'change'}
        ],
      },
      pathfrom: null,
    };
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
      admin: state => state.user.admin
    }),
  },
  created() {
    this.pathfrom = this.$route.query.pathfrom;
  },
  mounted() {
    document.title = (this.student.studentName ? '修改' : '填写') + '资料'
    // console.info(JSON.stringify(this.provinceAndCityData));
    this.getCascadeMajor();
  },
  methods: {
    getCascadeMajor() {
      let url = "/constub/getCascadeMajor";
      let data = {token: this.student.token,};
      HttpRequest.requestFormPost(url, data).then((res) => {
        if (res && res.result.success) {
          this.collegeAndMajorData = res.data;
          // console.info(JSON.stringify(this.collegeAndMajorData));
          this.initData();
        } else {
          this.$message({
            message: res.result.message,
            type: "error",
          });
        }
      });
    },
    initData() {
      this.formData.token = this.student.token;
      this.formData.studentNo = this.student.studentNo;
      this.formData.studentName = this.student.studentName;
      this.formData.studentGendar = this.student.studentGendar;
      this.formData.studentGrade = this.student.studentGrade;
      this.formData.studentBirtYear = this.student.studentBirtYear;
      this.formData.studentDegree = this.student.studentDegree;
      //
      this.formData.collegeAndMajor.push(this.student.studentCollege);
      this.formData.collegeAndMajor.push(this.student.studentMajor);
      if (this.student.studentHome) {
        let province = this.student.studentHome.split('/')[0];
        let city = this.student.studentHome.split('/')[1];
        this.formData.studentHome = [TextToCode[province].code, TextToCode[province][city].code];
        console.info(JSON.stringify(this.formData.studentHome));
      }
    },
    cancalEdit() {
      this.$router.push('/personalData');
    },
    //编辑资料-保存
    saveEditStudent() {
      this.$refs["formEdit"].validate((valid) => {
        if (valid) {
          // console.info(JSON.stringify(this.formData.studentHome));
          let provCode = this.formData.studentHome[0];
          let cityCode = this.formData.studentHome[1];
          this.formData.studentHome = [CodeToText[provCode], CodeToText[cityCode]];
          const options = {
            method: "POST",
            headers: {"content-type": "application/x-www-form-urlencoded"},
            data: qs.stringify(this.formData, {arrayFormat: 'repeat'}),
            url: "/constub/updateStudentInfo",
          };
          axios(options).then((res) => {
            res = res.data;
            if (res.result.success) {
              store.dispatch('setStudent', res.data);
              let open_homepage = (this.admin && this.admin.jsonSetting && this.admin.jsonSetting.open_homepage) || undefined;
              if (this.pathfrom){
                if (this.pathfrom === 'home' || this.pathfrom === 'pavilionAppoint' || this.pathfrom === open_homepage)
                  this.$router.push(this.pathfrom);
                else
                  this.$router.push({
                    name:'simpleQuestIntro',
                    params:{'questCode':this.pathfrom}
                  })
              } else
                this.$router.push('/personalData');
            } else {
              this.$alert(res.result.message, {
                confirmButtonText: '确定',
                showClose: false,
              });
            }
          });
        }
      });
    },
  }
};
</script>


<style scoped>
/* >>>.el-form-item{
  margin-bottom: 10px;
}
.el-form--label-top >>>.el-form-item__label{
  padding:10;
  line-height: 18px
} */
.box-card {
  padding: 15px;
}

.info_box {
  margin-top: 20px;
  /*height: 65px;*/
}

.el-select {
  width: 100%
}

.el_button_2 {
  width: 48%;
}

>>> .el-input-group__append,
>>> .el-input-group__prepend {
  border: 0;
  border-radius: 0;
  background: none;
  border-bottom: 1px solid #d2d9f1;
}

>>> .el-input__inner {
  color: #343c6d;
  font-weight: bold;
  background: none;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #d2d9f1;
  padding: 0 0;
  height: 30px;
}

>>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #343c6d;
  background: #343c6d;
}

>>> .el-radio__input.is-checked + .el-radio__label {
  color: #343c6d;
}

>>> .el-form-item__content {
  margin-left: 0 !important;
  line-height: 25px;
}

>>> .el-form-item{
  margin-bottom: 0;
}

>>> .el-input{
  height: 30px;
}

.button_center{
  text-align: center;
}

/*.info_box_down{*/
/*  height: 57px;*/
/*  position: absolute;*/
/*}*/

/*.info_box_down_i{*/
/*  position: absolute;*/
/*}*/

</style>
